export default "__VITE_ASSET__Bm27t$gS__"